import React from "react";
import TiptapEditor from "../../../ui/TiptapEditor";


function PickUpInFormation({ value, setValue }) {
    return (
        <section className="mt-6">
            <h3 className="text-lg font-semibold mb-2">
               Pick Up Information
            </h3>
            <TiptapEditor
                content={value}
                onChange={setValue}
                placeholder="Start writing your template..."
            />

        </section>
    )
}

export default PickUpInFormation